import { combineReducers } from "redux";
import { apiKeyReducer } from "./reducers/apiKeyReducers";
import { metaDataReducer } from "./reducers/metadataReducers";
import { entitlementReducer } from "./reducers/entitlementReducers";
import { productReducer } from "./reducers/productReducers";
import { userReducer } from "./reducers/userReducers";
import errorReducer from "./reducers/errorReducer";
import requestingReducer from "./reducers/requestingReducer";
import {isManagementViewEnabled } from "../utilities/EnvironmentUtility";
import { widgetReducer } from "./reducers/widgetReducer";
import { initBackendReducer } from "./reducers/initBackendReducer";
import { checkUserInitialSetUp } from "./reducers/checkUserInitialSetUp";
import { fileServiceReducer } from "./reducers/fileServiceReducer";
import { billingReducer } from "./reducers/billingReducers";

const getReducers = () => {
  
  const reducers = {
    error: errorReducer,
    requesting: requestingReducer,
    apiKey: apiKeyReducer,
    checkUserSetUp: checkUserInitialSetUp,
    fileService: fileServiceReducer,
    entitlement: entitlementReducer,
  };

  if (isManagementViewEnabled()) {
    return {
      ...reducers,
      metaData: metaDataReducer,
      product: productReducer,
      user: userReducer,
      widgets: widgetReducer,
      initRequest: initBackendReducer,
      billing: billingReducer
    };
  }

  return reducers;
};

export const createRootReducer = () => combineReducers(getReducers());